import { ContentFragmentType } from '../content/contentBuilder/Content';
import { ColumnLayout } from '../content/contentBuilder/layouts';
export const getRoot = (content) => content.fragmentsById.get(content.rootId);
export const getRootValue = (content) => getRoot(content).value;
export const getSectionIds = (content) => () => getRootValue(content).sections;
export const getSectionById = (content) => (sectionId) => {
    const section = content.fragmentsById.get(sectionId);
    if (!section) {
        throw Error(`Section by id ${sectionId} not found`);
    }
    if (!isContentSection(section)) {
        throw Error(`Fragment with ID ${sectionId} is not section`);
    }
    return section;
};
export const getColumnById = (content) => (columnId) => {
    const column = content.fragmentsById.get(columnId);
    if (!column) {
        throw Error(`Column not found by id ${columnId}`);
    }
    if (!isColumn(column)) {
        throw Error(`Fragment with id ${columnId} is of type ${column.type}`);
    }
    return column;
};
export const getWidgetById = (content) => (widgetId) => {
    const widget = content.fragmentsById.get(widgetId);
    if (!widget) {
        throw Error(`Widget not found by id ${widgetId}`);
    }
    if (widget.type !== ContentFragmentType.Widget) {
        throw Error(`Fragment with id ${widgetId} is of type ${widget.type}`);
    }
    return widget;
};
export const isColumn = (fragment) => {
    return fragment.type === ContentFragmentType.Column;
};
export const isContentSection = (fragment) => {
    return fragment.type === ContentFragmentType.Section;
};
const getAllContentSections = (content) => {
    return content.fragmentsById
        .filter((fragment) => isContentSection(fragment))
        .toIndexedSeq()
        .toArray();
};
const isOneColumnLayoutSection = (contentSection) => contentSection.value.columnLayout === ColumnLayout.SingleColumn;
export const hasOnlyOneColumnLayout = (content) => {
    const contentSections = getAllContentSections(content);
    const onlySingleColumnLayout = contentSections.every((contentSection) => isOneColumnLayoutSection(contentSection));
    return onlySingleColumnLayout;
};
